import React from 'react';
import AnnotationToolBar from './AnnotationToolBar';
import {ControlButton, TscButtonType, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {themeStore} from '../../context/themeProvider';
import {quizDataStore} from '../../context/quizDataProvider';

const CommentControls = styled.div`
   display: flex;
   justify-content: flex-end;
   padding-bottom: .5rem;

   button {
      margin-left: 0.5rem;
   }
`;

const SubmitButtonWrapper = styled.div`
   button {
      padding: 0 0.5rem;
   }
`;

export const CommentSubmitBase: React.FC<ICommentSubmitProps & IStateMappedProps> = ({isDisabled, isReply, setAnnotationExists, onSubmit, theme, IsQuizzing}) => {
   const {t} = useTranslation();

   return (
      <CommentControls>
         {!isReply && !IsQuizzing && <AnnotationToolBar setAnnotationExists={setAnnotationExists} />}
         <SubmitButtonWrapper>
            <ControlButton
               testId="submit-comment-button"
               buttonType={TscButtonType.primary}
               themeName={theme}
               label={t('general.submit')}
               title={t('general.submit')}
               onClick={onSubmit}
               disabled={isDisabled}
            />
         </SubmitButtonWrapper>
      </CommentControls>
   );
};

export interface ICommentSubmitProps {
   isDisabled: boolean;
   isReply: boolean;
   setAnnotationExists(annotationExists: boolean): void;
   onSubmit(): void;
}

export interface IStateMappedProps {
   theme: TscThemeNames;
   IsQuizzing: boolean;
}

const mapStatesToProps = (
   {isDisabled, isReply, setAnnotationExists, onSubmit}: ICommentSubmitProps,
   {theme}: Partial<IStateMappedProps>,
   {IsQuizzing}: Partial<IStateMappedProps>
): ICommentSubmitProps & IStateMappedProps => ({isDisabled, isReply, setAnnotationExists, onSubmit, theme, IsQuizzing});

export default withMemoizedContexts(mapStatesToProps, themeStore, quizDataStore)(CommentSubmitBase);
